import * as types from './types'

export const mutations = {
	[types.CLEAR_THREAD] (state) {
		state.threads = []
	},
	[types.NEW_THREAD] (state, thread) {
		state.threads.push(thread)
	},
	[types.NEW_MESSAGE] (state, data) {
		state.threads.forEach((thread) => {
			if (thread.id === data.id) {
				thread.messages.push(data.message)
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Chat/mutations.js